import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
// NOTE: React.StrictMode intentionally double-mounts components in dev to
// surface side-effect bugs.  It interacts badly with our HTML5 <video>
// element on the viewer route (`/v/:token`) — the abort-on-unmount on the
// first mount leaves the second mount's video element with no in-flight
// fetch, so playback never starts in dev.  Production builds don't have
// strict mode, so disabling it here is safe.  Re-enable for the next
// audit once the player has its own dedicated entry point.
root.render(<App />);
